var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useMemo } from 'react';
import { CircularButton } from './circular-ghost-button-styles';
import { getDiameter } from './../../utils';
var CircularGhostButton = forwardRef(function (_a, ref) {
    var children = _a.children, radius = _a.radius, borderWidth = _a.borderWidth, borderColor = _a.borderColor, _b = _a.hoverEffect, hoverEffect = _b === void 0 ? true : _b, fillColor = _a.fillColor, props = __rest(_a, ["children", "radius", "borderWidth", "borderColor", "hoverEffect", "fillColor"]);
    var diameter = useMemo(function () { return getDiameter(radius); }, [radius]);
    return (React.createElement(CircularButton, __assign({ hoverEffect: hoverEffect, diameter: diameter, borderWidth: borderWidth, borderColor: borderColor, fillColor: fillColor }, props, { ref: ref }), children));
});
CircularGhostButton.displayName = 'CircularGhostButton';
export default CircularGhostButton;
